module.exports = __webpack_public_path__ + "static/media/obsessive Compulsive Disorder.6f9fe3ad.svg";